import styled from 'styled-components'

export const Greeting = styled.h1`
    font-size: ${props => props.theme.fontSize.xLarge};
    font-family: ${props => props.theme.fontFamily.secondary};
    font-weight: ${props => props.theme.fontWeight.bold};
    color: ${props => props.theme.color.color100};
`